import logoUrl from './logo.svg';

/**
 * 共有 URL の画面(V02)に出す自社のロゴ(#318 / [ADR-0053](../../../../docs/adr/0053-share-link-logo.md))。
 *
 * - **ページ(V02 の外枠)だけが使う。** シェルと埋め込み(V01)はこのモジュールを読まない ——
 *   embed.js の成果物にロゴは入らない(決定 4)
 * - **盤面の外に置く。** 書き出し(合成処理)にロゴの経路は無い
 * - **`<img>` で読む。** SVG をインラインの DOM に差し込まない(決定 5)
 * - 原本は白一色・暗い背景用。縦横比は viewBox の `204 × 54.57`
 */

/** 代替テキスト(同意書の A5)。 */
export const LOGO_ALT = 'シルバーアイ';

/** ロゴの高さ(px —— 決定 6)。幅は縦横比から決まる。 */
export const LOGO_HEIGHT = 24;

/** 原本の縦横比(viewBox の幅 / 高さ)。 */
const LOGO_ASPECT = 204 / 54.57;

/**
 * ロゴを出すか。**項目が無ければ出さない** —— 配備の直後は、項目の無い古いキャッシュの応答が
 * 最大 60 秒残る(決定 3)。
 */
export function shouldShowLogo(data: { readonly showLogo?: boolean | undefined }): boolean {
  return data.showLogo === true;
}

/**
 * ロゴの寸法の宣言(CSS)。**幅も高さも固定する** —— 画像の読み込みに失敗しても帯の高さが
 * 崩れない(盤面の高さの上限は帯の高さから決まる)。
 */
export function logoSizeDeclarations(): string {
  const width = Math.round(LOGO_HEIGHT * LOGO_ASPECT);
  return `display: block; flex: none; width: ${String(width)}px; height: ${String(LOGO_HEIGHT)}px;`;
}

/** ロゴの画像。**リンクにしない**(押しても何も起きない —— 同意書の A6)。 */
export function createLogo(className: string): HTMLImageElement {
  const img = document.createElement('img');
  img.className = className;
  img.src = logoUrl;
  img.alt = LOGO_ALT;
  img.decoding = 'async';
  return img;
}
